import { productLowStockVitrineCount } from '../../utils/productStock.js';

const BADGE_TEXT_SHADOW = '0 1px 2px rgba(220, 38, 38, 0.75), 0 0 10px rgba(239, 68, 68, 0.45)';

/**
 * Badge «🔥 ÚLTIMAS N» na vitrine (stock entre 1 e 10).
 *
 * @param {{
 *   product: Record<string, unknown>|null|undefined,
 *   className?: string,
 *   overlay?: boolean,
 * }} props
 */
export function ProductLowStockHint({ product, className = '', overlay = true }) {
  const count = productLowStockVitrineCount(product);
  if (count === null) return null;

  const badgeText = count === 1 ? 'ÚLTIMA PEÇA' : `ÚLTIMAS ${count}`;
  const ariaLabel = count === 1 ? 'Última peça em estoque' : `Últimas ${count} unidades em estoque`;

  const pill = (
    <span
      className="inline-flex items-center gap-1 rounded-full border border-orange-200/90 bg-[#fff4ed]/95 px-2.5 py-1 shadow-[0_2px_8px_rgba(234,88,12,0.22)] backdrop-blur-[1px] dark:border-orange-900/50 dark:bg-orange-950/85"
      title={count === 1 ? 'Última peça em estoque' : `Restam apenas ${count} unidades em estoque`}
    >
      <span className="text-sm leading-none" aria-hidden>
        🔥
      </span>
      <span
        className="text-[10px] font-extrabold uppercase tracking-[0.12em] text-orange-600 dark:text-orange-400"
        style={{ textShadow: BADGE_TEXT_SHADOW }}
      >
        {badgeText}
      </span>
    </span>
  );

  if (!overlay) {
    return <div className={className.trim()}>{pill}</div>;
  }

  return (
    <div
      className={`pointer-events-none absolute bottom-2 left-2 z-[3] sm:bottom-2.5 sm:left-2.5 ${className}`.trim()}
      aria-label={ariaLabel}
    >
      {pill}
    </div>
  );
}
